/**
 * Study Mode CTA component - Final call-to-action section
 */

import {Link} from 'react-router-dom';
import {Container} from '../ui/Container';
import {Section} from '../ui/Section';
import {Button} from '../ui/Button';
import {ROUTES} from '../../config/constants';
import {useScrollAnimation} from '../../hooks/useScrollAnimation';

export function StudyCTA() {
  const {ref, isVisible} = useScrollAnimation();

  return (
    <Section padding="lg" background="white" ref={ref} className="bg-background dark:bg-[#1E1E1E] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.02] dark:opacity-[0.03]">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <Container className="relative z-10">
        <div className={`max-w-4xl mx-auto transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {/* Main CTA */}
          <div className="text-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-textPrimary dark:text-[#CCCCCC] mb-6 leading-tight">
              Try VoxaPilot Study Mode Now.
            </h2>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Link to={ROUTES.STUDY_APP}>
                <Button variant="primary" size="lg" className="w-full sm:w-auto bg-[#1E1E1E] dark:bg-[#1E1E1E] text-white hover:bg-[#2D2D30] dark:hover:bg-[#2D2D30] shadow-lg hover:shadow-xl transition-shadow">
                  Get Started Free
                </Button>
              </Link>
              <Link to={ROUTES.STUDY_MODE_PRICING}>
                <Button variant="outline" size="lg" className="w-full sm:w-auto border-2 hover:border-orange-500/50 transition-colors">
                  View Pricing
                </Button>
              </Link>
            </div>

            {/* Availability Info */}
            <div className="flex items-center justify-center gap-2 text-sm text-textTertiary dark:text-[#6A6A6A]">
              <svg className="w-4 h-4 text-orange-600/70 dark:text-orange-500/70" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span>Available on web only. Desktop app and mobile app coming soon.</span>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}

